import { MapTool } from '@bs/map';
import WKT from 'ol/format/WKT';
import 'ol/ol.css';
import { Fill, Icon, Style as OLStyle, Stroke, Text } from 'ol/style';
import { Button } from 'primereact/button';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Sidebar } from 'primereact/sidebar';
import { SplitButton } from 'primereact/splitbutton';
import { Tag } from 'primereact/tag';
import { Toast } from 'primereact/toast';
import { Tree as PrimeReactTree } from 'primereact/tree';
import React, { Component, createRef } from 'react';
import { withTranslation } from 'react-i18next';
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { layerContext } from '../../contexts/LayerContext';
import otherTool from '../../tools/otherTool';
import LoadingPanel from '../LoadingPanel';
import FieldCalculate from '../SmartTerritory.js/FieldCalculate';
import AddGeometryComponent from './AddGeometryComponent';
import { GeometryMenuRequest } from './GeometryMenuRequest';
import './LayerControl.css';
import LayerControlFileExport from './LayerControlFileExport';
import OperationLayer from './OperationLayer';
import { TreeService } from "./TreeService";




class LayerControl extends Component {
    treeIndex = null;

    sidebarScrollEl = null;
    lastSidebarScrollTop = 0;
    searchTimeout = null; // 🔹 arama debounce timer

    static contextType = layerContext;
    toast = createRef(null);
    dialClicked = false;

    state = {
        expandedKeys: {},
        expandedNodes: null,
        expandedTreeData: [],
        subLayerDialogStat: false,
        defaultCheckedLayers: [],
        selectedNode: null,
        updatedSelectNode: null,
        selectedNodeObject: null,
        treeData: [],
        selectedTab: 0,
        visible: true,
        parentId: 0,
        user_id: 0,
        activeIndex: 0,
        openAddNewFolderModal: false,
        treeObjectData: [],
        checkedObject: [],
        deleteObject: false,
        topCalculate: 243,
        showSelectedAllDraw: false,
        showAddSelectedObjectFeature: false,
        openDeleteObjectModal: false,
        openConfirmDrawingModal: false,
        openSaveWorkspaceModal: false,
        deleteFolder: false,
        deleteFolderConfirmPanel: false,
        modalProp: false,
        filterHierarchical: '',
        baseLayerDialogStat: false,
        treeDatav2: [],
        showAddPanel: false,
        layerProps: null,
        deletedNode: null,
        filteredNodes: [],
        searchValue: '',
        handleDrawAction: false,
        selectedDrawNode: null,
        handleInfoPageAction: false,
        visibleSidebar: false,
        buttonLeftPositionDefault: '5px',
        buttonLeftIconDefault: 'pi pi-arrow-right',
        selectedKeys: null,
        isLoading: false,
        layerName: null,
        layerType: null,
        isExistLayer: true,
        opacity: 0.60,
        selectedDeleteLayers: [],
        showDeleteLayersDialog: false,
        selecteDeleteNames: [],
        layerGeomType: null,
        draftTables: [],
        isDraftMode: false,
        selectedDraftTable: null,
        activeTreeTableName: null,
        selectedNodeColor: null,
        selectedStructureId: 0,
        selectedIntersectLayers: [],
        showWaybillDetail: false,
        calculateAreaDatas: [],
        selectedDrawLayer: null,
        isColoseActiveDraw: false,
        showExportDialog: false,
        exportFeature: [],
        isSelecteLayerChecked: false,
        isCheckedAll: false,
        isSearching: false
    };

    activeLayers = [];

    selectedLayer = null;

    selectedObject = null;

    activeObjects = [];

    mapTool = null;

    observer = null;

    load = async () => {

        const { t } = this.props;
        this.addGeometryRef = createRef();

        this.setState({
            isLoading: true
        })
        var treeAuthorization = await TreeService.GetTreeAuthorization();

        if (!treeAuthorization) {
            this.toast.current.show({
                severity: 'warn',
                summary: t('layerControl.toast_info'),
                detail: t('layerControl.toast_tree_not_loaded')
            });
            this.setState({
                isLoading: false
            })

            return;
        }

        if (treeAuthorization.success && treeAuthorization.data && treeAuthorization.data.length) {
            this.setState({ authorizationLayers: treeAuthorization.data });
        }

        const isDraft = this.props.isDraftTree;

        if (!isDraft) {
            await this.GetTree();

        }

        if (isDraft) {

            this.setState({
                isDraftMode: true,
                selectedDraftTable: null
            });

            await this.GetDraftTables();

        }

        this.setState({
            isLoading: false
        })

        this.mapTool = this.props.map?.current?.mapTool;

        const showLayer = MapTool.createVectorLayer({
            name: "show_layer",
            source: MapTool.createVectorLayerSource({})
        })
        showLayer.setZIndex(10);

        if (this.mapTool) {
            this.mapTool.addLayer(showLayer);
        }
        else {
            if (this.props.mapTool) {
                this.props.mapTool.addLayer(showLayer);
            }
        }
    }
    async componentDidMount() {

        this.load();

    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.treeData !== prevState.treeData && this.state.searchValue) {
            this.applyFilterNow(); // ağacı değiştiren load/GetTree sonrası bir kere çalışır
        }


        if (this.props.isReloadTree === true && prevProps.isReloadTree !== this.props.isReloadTree) {
            this.GetTree();
        }

        if (this.sidebarScrollEl) {
            this.sidebarScrollEl.scrollTop = this.lastSidebarScrollTop || 0;
        }
    }

    handleSidebarScroll = (e) => {
        if (!e || !e.target) return;
        this.lastSidebarScrollTop = e.target.scrollTop;
    };


    handleSidebarShow = () => {
        // Sidebar portal ile body'ye basılıyor, bu event geldiğinde DOM hazır oluyor
        setTimeout(() => {
            const el = document.querySelector('.tree-sidebar .p-sidebar-content');

            // burası senin eski 'el' aldığın yer
            if (el) {
                this.sidebarScrollEl = el;
                this.sidebarScrollEl.addEventListener('scroll', this.handleSidebarScroll);

                // daha önce kaydettiysen scrollTop'u geri yükle
                if (typeof this.lastSidebarScrollTop === 'number') {
                    this.sidebarScrollEl.scrollTop = this.lastSidebarScrollTop;
                }
            }
        }, 0);
    };

    handleSidebarHide = () => {
        // sidebar kapanırken event temizliği
        if (this.sidebarScrollEl) {
            this.sidebarScrollEl.removeEventListener('scroll', this.handleSidebarScroll);
            this.sidebarScrollEl = null;
        }
    };

    componentWillUnmount() {
        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout);
        }

        if (this.sidebarScrollEl) {
            this.sidebarScrollEl.removeEventListener('scroll', this.handleSidebarScroll);
            this.sidebarScrollEl = null;
        }
    }




    GetTree = async () => {
        const { t } = this.props;
        this.setState({ isLoading: true });

        try {
            let _response = await TreeService.GetTree();

            if (!_response || !_response.success || !Array.isArray(_response.data.treeList)) {
                this.setState({ treeData: [], filteredNodes: [] }, () => {
                    // index sıfırla
                    this.buildIndex(this.state.treeData);
                    // seçimleri de sıfırla/buda
                    this.pruneSelections(new Set());
                });

                this.toast.current.show({
                    severity: 'warn',
                    summary: t('layerControl.toast_info'),
                    detail: t('layerControl.toast_tree_not_loaded')
                });
                return;
            }

            if (_response.success) {

                const data = _response.data.treeList;

                const permissions = _response.data.permissions;


                this.setState({ permissions: permissions });

                //this.setState({ treeData: _response.data });
                this.setState(prev => {
                    const filtered = prev.searchValue
                        ? this.filterNodes(prev.searchValue, data)
                        : [];
                    return { treeData: data, filteredNodes: filtered };
                }, () => {
                    // index kur
                    this.buildIndex(this.state.treeData);
                    // mevcut seçimleri, yeni ağaçtaki geçerli id'lere göre buda
                    const validIds = new Set(this.flattenIds(this.state.treeData));
                    this.pruneSelections(validIds);
                });

            }
        } catch (error) {
            this.setState({ treeData: [], filteredNodes: [] });
            this.toast.current.show({
                severity: 'error',
                summary: t('layerControl.toast_info'),
                detail: t('layerControl.toast_tree_not_loaded')
            });
        } finally {
            this.setState({ isLoading: false });

        }



    }

    GetDraftTables = async () => {
        const { t } = this.props;
        try {

            let res = await TreeService.GetDraftTables();

            if (!res || !res.success) {
                this.toast.current.show({
                    severity: 'warn',
                    summary: t('layerControl.toast_info'),
                    detail: t('layerControl.toast_draft_tables_not_loaded')
                });
                return;
            }
            this.setState({
                draftTables: res.data,
                treeData: []
            });

        } catch (e) {
            this.toast.current.show({
                severity: 'warn',
                summary: t('layerControl.toast_info'),
                detail: t('layerControl.toast_draft_tables_not_loaded')
            });

        }


    }

    flattenIds = (nodes) => {
        const out = [];
        const walk = (arr) => {
            (arr || []).forEach(n => {
                if (!n) return;
                out.push(Number(n.id));
                if (n.children && n.children.length) walk(n.children);
            });
        };
        walk(nodes || []);
        return out;
    };

    pruneSelections = (validIds) => {
        const selectedKeys = { ...(this.state.selectedKeys || {}) };
        Object.keys(selectedKeys).forEach(k => {
            if (!validIds.has(Number(k))) delete selectedKeys[k];
        });
        const selectedDeleteLayers = this.state.selectedDeleteLayers.filter(id => validIds.has(Number(id)));
        const exportFeature = this.state.exportFeature.filter(obj => validIds.has(Number(obj.value)));

        this.setState({ selectedKeys, selectedDeleteLayers, exportFeature });
    };



    getDrafTableRecords = async (tableId) => {
        const { t } = this.props;

        this.setState({ treeData: [], isLoading: true });

        try {
            const res = await TreeService.GetDraftTableRecors(tableId);

            const data = (res && res.success && Array.isArray(res.data)) ? res.data : [];

            this.setState(prev => {
                const filtered = prev.searchValue
                    ? this.filterNodes(prev.searchValue, data)
                    : [];
                return {
                    isLoading: false,
                    treeData: data,
                    filteredNodes: filtered
                };
            }, () => {
                // index kur
                this.buildIndex(this.state.treeData);
                // seçimleri geçerli ID’lere göre buda
                const validIds = new Set(this.flattenIds(this.state.treeData));
                this.pruneSelections(validIds);
            });

        } catch (e) {
            this.setState({ isLoading: false });
            this.toast.current.show({
                severity: 'warn',
                summary: t('layerControl.toast_info'),
                detail: t('layerControl.toast_draft_records_not_loaded')
            });
        }
    };

    applyFilterNow = () => {
        const { searchValue, treeData } = this.state;
        const text = (searchValue || '').trim();

        if (!text) {
            this.setState({
                filteredNodes: [],
                expandedKeys: {},
                isSearching: false   // 🔹 arama boşsa loading kapat
            });
            return;
        }

        // (Opsiyonel) min karakter
        if (text.length < 2) {
            this.setState({
                filteredNodes: [],
                expandedKeys: {},
                isSearching: false   // 🔹 kısa aramada da kapat
            });
            return;
        }

        const filteredNodes = this.filterNodes(text, treeData || []);
        const expandedKeys = this.buildExpandedKeysFromNodes(filteredNodes);

        this.setState({
            filteredNodes,
            expandedKeys,
            isSearching: false       // 🔹 filtre bitti, loading kapat
        });
    };




    filterNodes = (searchValue, nodes) => {
        const normalizedSearch = this.normalizeText(searchValue);

        const loop = (list) => {
            const out = [];

            for (const node of list || []) {
                // _normName index’ten gelir; yoksa bir defa üret
                const nodeName = node._normName ?? this.normalizeText(node.name || node.label || '');
                const selfMatch = nodeName.includes(normalizedSearch);

                // Önce çocukları dolaş (ancestor’lar için)
                const filteredChildren = node.children && node.children.length
                    ? loop(node.children)
                    : [];

                if (selfMatch) {
                    // 🔥 Node kendisi arama ile eşleşiyorsa:
                    // - Node’u tut
                    // - VE TÜM çocuklarını (filtrelemeden) getir
                    out.push({
                        ...node,
                        children: node.children || []
                    });
                } else if (filteredChildren.length > 0) {
                    // ✅ Kendisi eşleşmedi ama torunlarından biri eşleştiyse:
                    // - Parent olarak node’u tut
                    // - Sadece eşleşme içeren dalları çocuklara koy
                    out.push({
                        ...node,
                        children: filteredChildren
                    });
                }
                // ne kendisi ne de çocukları eşleşiyorsa, node tamamen düşer
            }

            return out;
        };

        return loop(nodes || []);
    };

    buildExpandedKeysFromNodes = (nodes) => {
        const expanded = {};

        const walk = (list) => {
            (list || []).forEach(n => {
                if (n.children && n.children.length) {
                    expanded[n.id] = true; // bu node expand olsun
                    walk(n.children);
                }
            });
        };

        walk(nodes || []);
        return expanded;
    };



    changeDraftTables = async (e) => {
        const { t } = this.props;
        const tableId = e?.value?.id;

        if (!tableId) return;

        try {
            this.setState({
                selectedDraftTable: e.value,
                isLoading: true,
                treeData: []
            });

            const res = await TreeService.GetDraftTableRecors(tableId);
            const data = (res && res.success && Array.isArray(res.data)) ? res.data : [];

            this.setState(prev => {
                const filtered = prev.searchValue
                    ? this.filterNodes(prev.searchValue, data)
                    : [];
                return {
                    isLoading: false,
                    treeData: data,
                    filteredNodes: filtered
                };
            }, () => {
                // index kur
                this.buildIndex(this.state.treeData);
                // seçimleri geçerli ID’lere göre buda
                const validIds = new Set(this.flattenIds(this.state.treeData));
                this.pruneSelections(validIds);
            });

            if (!res || !res.success) {
                this.toast.current.show({
                    severity: 'warn',
                    summary: t('layerControl.toast_info'),
                    detail: t('layerControl.toast_draft_records_not_loaded')
                });
            }

        } catch (e) {
            this.setState({ isLoading: false });
            this.toast.current.show({
                severity: 'warn',
                summary: t('layerControl.toast_info'),
                detail: t('layerControl.toast_draft_records_not_loaded')
            });
        }
    };


    setVisible = (data) => {
        this.setState({ buttonLeftPositionDefault: '5px', buttonLeftIconDefault: 'pi pi-arrow-right' });

        this.props.setToolMenuCss(null);

        if (!this.state.visibleSidebar) {

            this.setState({ buttonLeftPositionDefault: '521px', buttonLeftIconDefault: 'pi pi-arrow-left' });

            this.props.setToolMenuCss({ position: 'absolute', left: '521px', top: 'calc(100%/2)' });
        }


        this.setState({ visibleSidebar: !this.state.visibleSidebar });
    }

    dragDropTree = async (e) => {

        const { t } = this.props;
        const draggedNodeId = e.dragNode.id;

        let parentNodeId = 0;

        if (e.dropNode) {
            parentNodeId = e.dropNode.id;

        }


        try {


            let requestData = {
                dragNodeId: draggedNodeId,
                parentId: parentNodeId
            };

            this.setState({
                loading: true
            })

            let response = await TreeService.UpdateParentId(requestData);

            this.setState({
                loading: false
            })

            if (!response.success) {

                this.toast.current.show({
                    severity: 'error',
                    summary: t('layerControl.toast_info'),
                    detail: t('layerControl.toast_tree_not_updated')
                });

                return;

            }

            this.setState({ treeData: e.value });

        } catch (e) {
            this.toast.current.show({
                severity: 'error',
                summary: t('layerControl.toast_info'),
                detail: t('layerControl.toast_tree_not_updated')
            });
        }
    }

    createHeaderSideBar = () => {
        const { t } = this.props;

        return (
            <>
                <div className="tree-container-header-main">
                    <div className="tree-container-header-text">
                        <div className="flex  align-items-center w-full">
                            <h3 className="m-0">{t('layerControl.header_title')}</h3>
                            <Button
                                tooltip={t('homepage.menu.user_guide')}
                                icon="pi pi-question-circle"
                                link
                                onClick={() =>
                                    window.open(
                                        process.env.REACT_APP_USER_MANUEL + "/docs/HiyerarsikAgacYapısı",
                                        '_blank'
                                    )
                                }
                            />
                        </div>
                        <div>
                            <div style={{ position: 'relative', display: 'inline-block' }}>
                                <InputText
                                    id="filter"
                                    value={this.state.searchValue}
                                    style={{ height: '30px', width: '200px', paddingRight: '28px' }}
                                    placeholder={t('layerControl.filter_placeholder')}
                                    onChange={this.setFilterValue}
                                />

                                {this.state.isSearching && (
                                    <i
                                        className="pi pi-spinner pi-spin"
                                        style={{
                                            position: 'absolute',
                                            right: '8px',
                                            top: '50%',
                                            transform: 'translateY(-50%)',
                                            fontSize: '0.8rem',
                                            color: '#6b7280',
                                            pointerEvents: 'none'
                                        }}
                                    />
                                )}
                            </div>
                        </div>

                    </div>
                    <div className="tree-container-header-buttons">

                        {window.Object.checkPermissions(["draw_tools"]) && <>
                            <Button severity="primary" icon="pi pi-plus" className="p-button-raised" tooltip={t('layerControl.tooltip_add_workspace')} onClick={() => this.handleAddClick(0)} />
                            <Button severity="danger" icon="pi pi-trash" className="p-button-raised" tooltip={t('layerControl.tooltip_delete_selected_layers')} onClick={this.deleteSelectedLayers} />

                        </>}
                    </div>


                </div>



            </>
        );
    }
    findItemById = (data, id) => {
        for (let item of data) {
            if (item.id === id) {
                return item;
            }
            if (item.children && item.children.length > 0) {
                const found = this.findItemById(item.children, id);
                if (found) {
                    return found;
                }
            }
        }
        return null;
    }
    findItemByColor = (data, id) => {
        for (let item of data) {
            if (item.id === id && item.color) {
                return item;
            }
        }
        return null;
    }
    findFirstNonEmptyParent = (arr, id, field) => {

        let found = false;
        let currentId = id;

        while (!found) {

            let parent = arr.find(item => item.id === currentId);

            if (!parent) break;

            if (parent[field]) {
                return parent;
            }
            currentId = parent.parentId;
        }

        return null;
    }

    disableCheckAll = () => {

        const { activeTreeTableName } = this.state;

        if (this.mapTool.findLayer('wms-layer-' + activeTreeTableName) != null) {

            this.mapTool.getMap().removeLayer(this.mapTool.findLayer('wms-layer-' + activeTreeTableName));


        }

        this.setState({
            selectedKeys: null,
            exportFeature: [],
            isCheckedAll: false
        });

    }

    checkAll = () => {
        const checkNode = (node) => {
            const checkedNode = {
                [node.id]: {
                    checked: true,
                    partialChecked: false
                }
            };

            // Eğer çocuk düğümleri varsa, onları da kontrol et
            if (node.children && node.children.length > 0) {
                node.children.forEach(child => {
                    Object.assign(checkedNode, checkNode(child));
                });
            }

            return checkedNode;
        };

        const checkedAll = this.state.treeData.reduce((acc, item) => {
            return { ...acc, ...checkNode(item) };
        }, {});

        const allIds = this.getAllIdsAsObjects();

        this.setState({
            selectedKeys: checkedAll,
            exportFeature: [...allIds],
            isCheckedAll: true
        });

        try {


            if (this.state.isDraftMode) {

                const tableId = this.state.selectedDraftTable.id;

                TreeService.GetActiveTreeTableName(tableId).then(result => {


                    if (!result.success) {

                        return;
                    }

                    let tableName = result.data;

                    this.setState({
                        activeTreeTableName: tableName
                    })

                    if (this.mapTool.findLayer('wms-layer-' + tableName) != null) {
                        this.mapTool.getMap().removeLayer(this.mapTool.findLayer('wms-layer-' + tableName));
                    }

                    let params = {
                        layers: ['geoterritory_get_all_data'],
                        viewParams: `table_name:${tableName}`
                    };

                    //Harita üzerinde kullanmak amacıyla layer oluşturulur
                    const wmsLayer = MapTool.createTileLayer({
                        name: 'wms-layer-' + tableName,
                        source: MapTool.createTileLayerSourceWithHeaders({
                            urls: [process.env.REACT_APP_DYNAMICTABLE_API_URL + "/DynamicLayer/GetMap"],
                            params: params,
                        }),
                    });
                    //Haritaya eklenir
                    this.mapTool.addLayer(wmsLayer);


                });

                return;
            }

            TreeService.GetActiveTreeTableName().then(result => {


                if (!result.success) {

                    return;
                }

                let tableName = result.data;


                this.setState({
                    activeTreeTableName: tableName
                })

                if (this.mapTool.findLayer('wms-layer-' + tableName) != null) {
                    this.mapTool.getMap().removeLayer(this.mapTool.findLayer('wms-layer-' + tableName));
                }

                let params = {
                    layers: ['geoterritory_get_all_data'],
                    viewParams: `table_name:${tableName}`
                };

                //Harita üzerinde kullanmak amacıyla layer oluşturulur
                const wmsLayer = MapTool.createTileLayer({
                    name: 'wms-layer-' + tableName,
                    source: MapTool.createTileLayerSourceWithHeaders({
                        urls: [process.env.REACT_APP_DYNAMICTABLE_API_URL + "/DynamicLayer/GetMap"],
                        params: params,
                    }),
                });
                //Haritaya eklenir
                this.mapTool.addLayer(wmsLayer);

            });



        } catch (e) {
            //this.setState({
            //    isLoading: false
            //})
        }

    }

    getAllIdsAsObjects = () => {
        const collectIdsAsObjects = (node) => {
            let ids = [{ key: "id", value: String(node.id) }];

            if (node.children && node.children.length > 0) {
                node.children.forEach(child => {
                    ids = ids.concat(collectIdsAsObjects(child));
                });
            }

            return ids;
        };

        const allIdsAsObjects = this.state.treeData.reduce((acc, item) => {
            return acc.concat(collectIdsAsObjects(item));
        }, []);

        return allIdsAsObjects;
    }


    selectNodeToShow = (e) => {

        if (!e.originalEvent.target.classList.contains("p-checkbox-box") && !e.originalEvent.target.classList.contains("p-checkbox-icon")) {
            return;
        }

        const oldKeys = Object.keys(this.state.selectedKeys ?? {});


        const newKeys = Object.keys(e.value);

        let changedKey = null;

        if (newKeys.length > oldKeys.length) {

            changedKey = newKeys.find(k => !oldKeys.includes(k));

        } else {

            changedKey = oldKeys.find(k => !newKeys.includes(k));

            if (this.state.selectedDrawLayer != null && changedKey == this.state.selectedDrawLayer.id) {

                this.setState({ isColoseActiveDraw: true });

                return;
            }

        }

        let _properties = Object.getOwnPropertyNames(e.value);

        let _checkedNodes = [];

        _properties.forEach(i => {

            if (e.value[i].checked) {

                _checkedNodes.push(i);
            }

        });




        //if (this.dialClicked) {

        //    this.dialClicked = false;

        //    return;
        //}


        this.setState({
            selectedKeys: e.value
        });


        this.setState({
            selectedDeleteLayers: [..._checkedNodes]
        });

        let requestData = [];

        _checkedNodes.forEach(i => {

            let _requestObject = { key: "id", value: i };

            requestData.push(_requestObject);

        })
        if (this.props.onCheckedNode) {
            return this.props.onCheckedNode(requestData);
        }

        this.setState({
            exportFeature: [...requestData],
            isLoading: true
        });


        try {
            //this.setState({
            //    isLoading: true
            //});

            if (this.state.isDraftMode) {

                const tableId = this.state.selectedDraftTable.id;

                TreeService.GetActiveTreeTableName(tableId).then(result => {

                    //this.setState({
                    //    isLoading: false
                    //})

                    if (!result.success) {

                        return;
                    }

                    let tableName = result.data;

                    this.setState({
                        activeTreeTableName: tableName
                    })

                    if (this.mapTool.findLayer('wms-layer-' + tableName) != null) {
                        this.mapTool.getMap().removeLayer(this.mapTool.findLayer('wms-layer-' + tableName));
                    }

                    let idList = _checkedNodes.join("\\,");

                    let params = {
                        layers: ['geoterritory_get_tree'],
                        viewParams: `table_name:${tableName};id_list:${idList}`
                    };

                    //Harita üzerinde kullanmak amacıyla layer oluşturulur
                    const wmsLayer = MapTool.createTileLayer({
                        name: 'wms-layer-' + tableName,
                        source: MapTool.createTileLayerSourceWithHeaders({
                            urls: [process.env.REACT_APP_DYNAMICTABLE_API_URL + "/DynamicLayer/GetMap"],
                            params: params,
                        }),
                    });
                    //Haritaya eklenir
                    this.mapTool.addLayer(wmsLayer);


                });





                return;
            }

            TreeService.GetActiveTreeTableName().then(result => {

                //this.setState({
                //    isLoading: false
                //})

                if (!result.success) {

                    return;
                }

                let tableName = result.data;


                this.setState({
                    activeTreeTableName: tableName
                })

                if (this.mapTool.findLayer('wms-layer-' + tableName) != null) {
                    this.mapTool.getMap().removeLayer(this.mapTool.findLayer('wms-layer-' + tableName));
                }

                let idList = _checkedNodes.join("\\,");

                let params = {
                    layers: ['geoterritory_get_tree'],
                    viewParams: `table_name:${tableName};id_list:${idList}`
                };

                //Harita üzerinde kullanmak amacıyla layer oluşturulur
                const wmsLayer = MapTool.createTileLayer({
                    name: 'wms-layer-' + tableName,
                    source: MapTool.createTileLayerSourceWithHeaders({
                        urls: [process.env.REACT_APP_DYNAMICTABLE_API_URL + "/DynamicLayer/GetMap"],
                        params: params,
                    }),
                });
                //Haritaya eklenir
                this.mapTool.addLayer(wmsLayer);

            });



            TreeService.GetLayersFromQuery(requestData).then(_result => {

                if (!_result.success) {


                    return;
                }
                //this.setState({
                //    isLoading: false
                //})
                let _data = _result.data;

                if (_data.length < 1) {

                    return;
                }

                let featureRemoveList = [];
                for (let i = 0; i < _data.length; i++) {

                    if (!_data[i].geoloc_wkt) {

                        continue;
                    }

                    let _wkt = _data[i].geoloc_wkt;

                    if (!_wkt) {
                        continue;
                    }


                    let _feature = MapTool.convertToFeature(_wkt, "EPSG:4326", "EPSG:3857");


                    _feature.set("layer_id", _data[i].id);

                    featureRemoveList.push(_feature);

                    this.mapTool.addFeature("workspace-layer", _feature);

                }

                if (this.mapTool.findLayer("workspace-layer").getSource().getFeatures().length < 1) {
                    return;
                }

                const _extent = this.mapTool.findLayer("workspace-layer").getSource().getExtent();

                this.mapTool.getMap().getView().fit(_extent, {
                    padding: [50, 50, 50, 50],
                    duration: 500,
                });



                featureRemoveList.forEach(feature => {
                    this.mapTool.findLayer("workspace-layer").getSource().removeFeature(feature);
                })


            });


        } catch (e) {

        }
        finally {
            this.setState({
                isLoading: false
            })
        }

    }

    onSelect = (event) => {
        toast.current.show({ severity: 'info', summary: 'Node Selected', detail: event.node.label });
    };
    hideSideBar = () => {
        this.setState({
            visible: !this.state.visible
        })
    }

    customIconSideBar = () => {

        return (<>

            <React.Fragment>
                <button className="p-link p-sidebar-close p-sidebar-icon mr-2" onClick={this.hideSideBar}>
                    <i class="pi pi-eye-slash"></i>
                </button>
            </React.Fragment>

        </>);

    }
    render = () => {
        const { isLoading } = this.state;
        const isLoadingProps = this.props.isLoading;

        const { t } = this.props;


        if (isLoading || isLoadingProps) {

            return (
                <>
                    <Toast ref={this.toast} />

                    <div id="blur">
                        <LoadingPanel className="tree-loading-panel" />
                    </div>
                </>
            )

        }

        const nodesToShow = this.state.searchValue ? this.state.filteredNodes : this.state.treeData;


        if (!nodesToShow) {
            return;
        }


        if (this.props.isOnlyTree) {

            return (
                <PrimeReactTree
                    selectionMode="single"
                    value={this.createTreeNodes(nodesToShow)}
                    className="w-full md:w-30rem"
                    onSelectionChange={(e) => {

                        const foundItem = this.findItemById(nodesToShow, e.value);
                        if (this.props.onSelectedNode) {
                            this.props.onSelectedNode(foundItem);
                        }
                        console.log(e);
                    }}


                />)
        }

        if (this.props.isOnlyTreeAndCheckBox) {

            let nodes = [{ id: 0, name: "Tümünü seç", children: nodesToShow }];



            return (
                <PrimeReactTree
                    selectionKeys={this.state.selectedKeys}
                    value={this.createTreeNodes(nodes)}
                    className="w-full md:w-30rem"
                    selectionMode="checkbox"
                    onSelectionChange={this.selectNodeToShow}
                    expandedKeys={nodes}

                />)
        }
        return (
            <>

                <Toast ref={this.toast} />

                <Dialog header={t('layerControl.dialog_warning_header')} visible={this.state.isColoseActiveDraw} style={{ width: '20vw' }} onHide={() => {
                    if (!this.state.isColoseActiveDraw) return;

                    const updatedSelectedKeys = { ...(this.state.selectedKeys || {}) };
                    if (this.state.selectedDrawLayer?.id) {
                        updatedSelectedKeys[this.state.selectedDrawLayer.id] = { checked: true, partialChecked: false };
                        this.setState({
                            isColoseActiveDraw: false,
                            selectedKeys: updatedSelectedKeys
                        });
                    }
                }} footer={() => {
                    return (
                        <div>
                            <Button onClick={() => {

                                if (this.addGeometryRef.current) {
                                    //Buraya true gönderilirse kayıttan sonra çizime devam edilmediği için çizimin tekrar getirilmesini engeller
                                    this.addGeometryRef.current.saveDraw(true);

                                }
                            }

                            } label={t('layerControl.button_save')} severity="success" icon="pi pi-save" autoFocus />
                            <Button label={t('layerControl.button_close_without_save')} severity="warning" icon="pi pi-times" onClick={() => {
                                this.setState({
                                    isColoseActiveDraw: false,
                                    handleDrawAction: false,
                                    selectedDrawLayer: null
                                });

                                this.toast.current.show({
                                    severity: 'info',
                                    summary: t('layerControl.toast_info'),
                                    detail: t('layerControl.toast_closed_without_saving')
                                });
                                this.addGeometryRef.current.clear();

                            }} />

                        </div>)
                }}>
                    <p className="m-0">
                        {t('layerControl.dialog_manage_active_draw_text')}
                    </p>
                </Dialog>
                <Sidebar
                    closeOnEscape={false}
                    className="tree-sidebar"
                    closeIcon={<i className="pi pi-times hide-sidebar-button" />}
                    modal={this.state.modalProp}
                    visible={this.state.visible}
                    dismissable={false}
                    header={this.createHeaderSideBar}
                    icons={this.customIconSideBar}
                    onShow={this.handleSidebarShow}             
                    onHide={() => {
                        this.handleSidebarHide();               

                        if (this.mapTool.findLayer('wms-layer-' + this.state.activeTreeTableName) != null) {
                            this.mapTool.getMap().removeLayer(this.mapTool.findLayer('wms-layer-' + this.state.activeTreeTableName))
                        }

                        this.props.setVisibleTree(false)
                    }}
                >


                    <div>
                        <br />
                        {this.state.isDraftMode && <Dropdown filter value={this.state.selectedDraftTable} onChange={this.changeDraftTables} options={this.state.draftTables} optionLabel="name" placeholder={t('layerControl.dropdown_select_draft_table')} checkmark={true} highlightOnSelect={false} className="w-full" />}

                        {window.Object.checkPermissions(["draw_tools"]) && <Button label={t('layerControl.button_show_all')} severity="secondary" text onClick={this.checkAll} />} 
                        <Button label={t('layerControl.button_uncheck_all')} severity="danger" text onClick={this.disableCheckAll} />
                        <Button label={t('layerControl.button_export')} icon="pi pi-download" severity="success" text onClick={() => this.setState({ showExportDialog: true })} />

                        <PrimeReactTree
                            value={this.createCustomTreeNodes(nodesToShow)}
                            className="w-23rem z-0 tree-control"
                            selectionMode="checkbox"
                            selectionKeys={this.state.selectedKeys}
                            onSelectionChange={this.selectNodeToShow}
                            dragdropScope="default" onDragDrop={this.dragDropTree}
                            propagateSelectionUp={false}
                            propagateSelectionDown={true}
                            expandedKeys={this.state.expandedKeys}
                            onToggle={(e) => this.setState({ expandedKeys: e.value })}
                        />



                    </div>

                </Sidebar>

                {!this.state.visible && <Button icon="pi pi-eye" onClick={this.hideSideBar} className="show-sidebar-button" />}

                {this.state.showAddPanel && <OperationLayer getDraftTree={this.getDrafTableRecords} isDraftMode={this.state.isDraftMode} selectedTable={this.state.selectedDraftTable} selectedNode={null} isExistLayer={this.state.isExistLayer} visible={this.state.showAddPanel} layerType={this.state.layerType} layerName={this.state.layerName} getTree={this.GetTree} layerProps={this.state.layerProps} onHide={() => this.setState({ showAddPanel: false })} thisToast={this.toast} updateParentState={this.updateParentStateInfoPage} isLoading={this.openLoadingFunction} />}

                {this.state.handleDrawAction && <AddGeometryComponent {...this.props} toast={this.toast} ref={this.addGeometryRef} layerName={this.state.selectedDrawLayer.name} isDraftMode={this.state.isDraftMode} selectedTable={this.state.selectedDraftTable} mapTool={this.props.map?.current?.mapTool} layerGeomType={this.state.layerGeomType} selectedNode={this.state.selectedDrawLayer} updateParentState={this.updateParentStateDrawAction} toastRef={toast} onDialog={() => {

                    this.setState({ isColoseActiveDraw: true });

                }} onClose={(status) => {

                    this.setState({
                        isColoseActiveDraw: false,
                        handleDrawAction: false,
                        selectedDrawLayer: null
                    });


                    if (status === true) {
                        this.toast.current.show({
                            severity: 'success',
                            summary: t('layerControl.toast_info'),
                            detail: t('layerControl.toast_saved_and_closed')
                        });
                        this.addGeometryRef.current.clear();
                    }

                    //else {
                    //    this.toast.current.show({ severity: 'success', summary: 'Bilgi', detail: "Çizim kaydedilmeden kapatıldı." });
                    //}


                }} />}

                {this.state.handleInfoPageAction && <OperationLayer isDraftMode={this.state.isDraftMode} getDraftTree={this.getDrafTableRecords} selectedTable={this.state.selectedDraftTable} layerName={this.state.layerName} isLoading={this.openLoadingFunction} onHide={() => this.setState({ showAddPanel: false })} selectedNode={this.state.selectedDrawNode} getTreeData={this.GetTree} updateParentState={this.updateParentStateInfoPage} layerType={this.state.layerType} />}

                <ConfirmDialog className="layer-control-confirm" />

                {this.state.showDeleteLayersDialog &&
                    <Dialog header={t('layerControl.dialog_delete_selected_layers_header')} footer={
                        <div style={{ display: 'flex', justifyContent: 'flex-start', "margin": "5px" }}>
                            <Button
                                label={t('layerControl.button_delete')}
                                className="p-button-danger"
                                onClick={this.handleDeleteLayerList}
                            />
                        </div>
                    } visible={this.state.showDeleteLayersDialog} onHide={() => { this.setState({ showDeleteLayersDialog: false }) }}>
                        <ul style={{ maxHeight: '200px', overflowY: 'auto' }}>
                            {this.state.selecteDeleteNames.map((name, index) => (
                                <li key={index}>{name}</li>
                            ))}
                        </ul>
                    </Dialog>}

                {(this.state.showWaybillDetail && this.state.selectedDrawNode) && <FieldCalculate
                    header={t('layerControl.field_calculate_header')}
                    apiUrl={process.env.REACT_APP_DYNAMICTABLE_API_URL}
                    tableId={this.state.selectedDraftTable.id}
                    layerId={this.state.selectedDrawNode.id}
                    onHide={() => this.setState({ showWaybillDetail: false })}

                />}

                {this.state.showExportDialog && (
                    <LayerControlFileExport
                        visible={this.state.showExportDialog}
                        onHide={() => this.setState({ showExportDialog: false })}
                        mapTool={this.mapTool}
                        featureIds={this.state.exportFeature}
                        hexToRGBA={this.hexToRGBA}
                    />
                )}



            </>


        )
    }

    handleDeleteLayerList = async () => {

        const { t } = this.props;

        this.setState({
            isLoading: true
        })
        const { selectedDeleteLayers } = this.state;

        let requestData = selectedDeleteLayers.map(item => parseInt(item));

        try {

            let response = await TreeService.DeleteLayers(requestData);

            if (!response.success) {

                this.toast.current.show({
                    severity: 'warn',
                    summary: t('layerControl.toast_info'),
                    detail: response.message
                });


                return;
            }


            this.toast.current.show({
                severity: 'success',
                summary: t('layerControl.toast_info'),
                detail: t('layerControl.toast_delete_success')
            });

            this.GetTree();

        } catch (e) {
            this.toast.current.show({
                severity: 'warn',
                summary: t('layerControl.toast_info'),
                detail: t('layerControl.toast_delete_failed')
            });

        } finally {
            this.setState({
                isLoading: false,
                showDeleteLayersDialog: false,
                selectedDeleteLayers: [],
                selecteDeleteNames: [],
                selectedKeys: null
            })
        }



    }

    openLoadingFunction = (state) => {
        this.setState({
            isLoading: state
        })
    }

    speddDialClick = (nodeId) => {
        this.dialClicked = true;
        this.setState({
            selectedNodeColor: nodeId
        });

    }

    layerControlManagement = () => {

        const baseUrl = process.env.PUBLIC_URL;
        window.location = baseUrl + '/layerControlSettings';
    }
    updateParentStateInfoPage = (newState) => {
        this.setState({ handleInfoPageAction: newState, showAddPanel: false })
    }

    updateParentStateDrawAction = (newState) => {
        this.setState({ handleDrawAction: newState })
    }


    setFilterValue = (event) => {
        const searchValue = event.target.value;

        // input değerini hemen state'e yaz
        this.setState({ searchValue });

        // Önce eski timer'ı temizle
        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout);
        }

        const trimmed = searchValue.trim();

        // Eğer arama tamamen temizlendiyse:
        if (!trimmed) {
            this.setState({
                filteredNodes: [],
                expandedKeys: {},
                isSearching: false
            });
            return;
        }

        // Minimum karakter kontrolü (mesela 2)
        if (trimmed.length < 2) {
            this.setState({
                filteredNodes: [],
                expandedKeys: {},
                isSearching: false
            });
            return;
        }

        // 🔹 Burada "arama hazırlanıyor" diye işaretle
        this.setState({ isSearching: true });

        // Debounce başlat
        this.searchTimeout = setTimeout(() => {
            this.applyFilterNow();
        }, 300); // 200–400ms arası idealdir
    };

    buildIndex = (nodes) => {
        const byId = new Map();

        const walk = (arr) => {
            for (const n of arr || []) {
                // düğüme bir defa yaz: _normName
                const base = (n && (n.name ?? n.label)) || '';
                n._normName = this.normalizeText(base);

                byId.set(n.id, n);
                if (n.children && n.children.length) walk(n.children);
            }
        };

        walk(nodes || []);
        this.treeIndex = { byId };
    };



    normalizeText = (text = "") => {
        return String(text)
            .toLowerCase()
            .normalize('NFD').replace(/[\u0300-\u036f]/g, '') // aksan
            .replace(/[çÇ]/g, 'c')
            .replace(/[ğĞ]/g, 'g')
            .replace(/[ıİ]/g, 'i')
            .replace(/[öÖ]/g, 'o')
            .replace(/[şŞ]/g, 's')
            .replace(/[üÜ]/g, 'u')
            .replace(/[^\w\s]/g, '') // noktalama
            .replace(/\s+/g, ' ')
            .trim();
    };


    showPolygon = (event) => {
        const { t } = this.props;
        let _wkt = event.geoloc_wkt;
        if (!_wkt) {
            this.toast.current.show({
                severity: 'warn',
                summary: t('layerControl.toast_info'),
                detail: t('layerControl.toast_wkt_not_found')
            });
            return;
        }
        let _feature = MapTool.convertToFeature(_wkt, "EPSG:4326", "EPSG:3857");
        this.zoomToFeature(_feature, 8);
    };


    showPoint = (event) => {
        const { t } = this.props;
        let _wkt = event.point_wkt;
        if (!_wkt) {
            this.toast.current.show({
                severity: 'warn',
                summary: t('layerControl.toast_info'),
                detail: t('layerControl.toast_wkt_not_found')
            });
            return;
        }
        const format = new WKT();
        const feature = format.readFeature(_wkt, {
            dataProjection: "EPSG:4326",
            featureProjection: "EPSG:3857",
        });
        const iconStyle = new OLStyle({
            image: new Icon({
                anchor: [0.5, 1],
                src: process.env.PUBLIC_URL + '/Images/dot.png',
            }),
        });
        feature.setStyle(iconStyle);
        MapTool.zoomToFeature(feature, 14);
    };



    handleAddClick = async (event) => {
        const { t } = this.props;

        try {
            if (this.state.isDraftMode && !this.state.selectedDraftTable) {
                this.toast.current.show({
                    severity: 'warn',
                    summary: t('layerControl.toast_info'),
                    detail: t('layerControl.toast_select_draft_table'),
                    life: 3000
                });
                return;
            }

            this.setState({ isLoading: true });

            let _parentId = 0;
            if (event.layertype) {
                _parentId = event.layertype;
            }

            let _layerName = '';
            let _layerType = 0;
            let _isExistLayer = true;

            let _res = await TreeService.GetLayerStructureByParentId(_parentId);

            if (!_res.success && this.state.isDraftMode) {
                this.toast.current.show({
                    severity: 'warn',
                    summary: t('layerControl.toast_info'),
                    detail: t('layerControl.toast_add_layer_in_draft_not_allowed'),
                    life: 3000
                });
                return;
            }

            if (!_res.success) {
                this.toast.current.show({
                    severity: 'warn',
                    summary: t('layerControl.toast_info'),
                    detail: _res.message,
                    life: 3000
                });
                _isExistLayer = false;
                _layerName = t('layerControl.unnamed_layer');
                _layerType = event.layertype + 1;
            }

            if (event == 0) {
                _layerType = 1;
            }

            if (_res.success) {
                _layerName = _res.data.name;
                _layerType = _res.data.layerId;
            }

            this.setState({
                showAddPanel: true,
                layerProps: event,
                layerName: _layerName,
                layerType: _layerType,
                isExistLayer: _isExistLayer
            });
        } catch (e) {
            // optional log
        } finally {
            this.setState({ isLoading: false });
        }
    };


    removeNode = (event) => {
        const { t } = this.props;

        let _id = this.state.deletedNode.id;

        if (this.state.isDraftMode) {
            const tableId = this.state.selectedDraftTable.id;

            TreeService.DeleteRecordDraftTable(_id, tableId).then(res => {
                if (res.success) {
                    this.toast.current.show({
                        severity: 'info',
                        summary: t('layerControl.toast_info'),
                        detail: t('layerControl.toast_delete_success')
                    });
                    this.getDrafTableRecords(tableId);
                }
                this.reject();
            });

            return;
        }

        TreeService.deleteLayer(_id).then(res => {
            if (res.success) {
                this.toast.current.show({
                    severity: 'info',
                    summary: t('layerControl.toast_info'),
                    detail: t('layerControl.toast_delete_success')
                });
                this.GetTree();
            }
            this.reject();
        });
    };


    reject = () => {
        return;
    }

    confirm = (event) => {
        const { t } = this.props;
        confirmDialog({
            target: event.currentTarget,
            message: t('layerControl.confirm_delete_message'),
            icon: 'pi pi-exclamation-triangle',
            defaultFocus: 'accept',
            accept: this.removeNode,
            reject: this.reject,
            acceptLabel: t('addGeometry.confirm_yes'),
            rejectLabel: t('addGeometry.confirm_no')
        });
    };

    getLayerStructure = async (node) => {
        const { t } = this.props;
        let _res = await TreeService.GetLayerStructure();

        if (!_res.success) {
            this.toast.current.show({ severity: 'warn', summary: t('layerControl.toast_info'), detail: _res.message, life: 3000 });
        }

        if (_res.success) {
            this.setState({
                layerName: _res.data.find(x => x.layerId === node.layertype)?.name,
                layerGeomType: _res.data.find(x => x.layerId === node.layertype)?.geomType
            });

            return _res.data.find(x => x.layerId === node.layertype).geomType;
        }
    };

    checkLockStatus = async (node) => {

        const { t } = this.props;

        const entityId = node.id;

        let response = await GeometryMenuRequest.lockStatus(entityId);

        if (!response.success) {

            this.toast.current.show({ severity: 'warn', summary: t('layerControl.toast_info'), detail: t('layerControl.check_lock_service_error'), life: 3000 });

            return false;
        }

        if (response.data.locked) {

            this.toast.current.show({ severity: 'warn', summary: t('layerControl.toast_info'), detail: t('layerControl.locked_by_user', { user: response.data.lockedUserName }), life: 3000 });

            return false;
        }

        return true;
    }

    lockEntity = async (nodeId) => {
        const { t } = this.props;

        let response = await GeometryMenuRequest.lockEntity(nodeId);

        if (!response.success) {

            this.toast.current.show({ severity: 'warn', summary: t('layerControl.toast_info'), detail: t('layerControl.check_lock_service_error'), life: 3000 });

        }
    }

    createCustomTreeNodes = (nodes) => {
        const { t } = this.props;

        if (!nodes) return;

        let nodes_temp = [];
        if (nodes.treeList) {
            nodes_temp = nodes.treeList.filter(i => i.name);
        }
        else {
            nodes_temp = nodes.filter(i => i.name);
        }
        nodes = nodes_temp;
        return nodes.map((node) => {

            const isNodeSelected = this.state.selectedNodeColor ? this.state.selectedNodeColor.id === node.id : false;
            let nodeNameTooltip = node.name;
            let nameShort = nodeNameTooltip;

            let authorization = this.state.authorizationLayers && this.state.authorizationLayers.length &&
                this.state.authorizationLayers.find(x => x.layerId === node.id || x.layerId === 0);

            let speedDialItems = [];

            if (this.state.isDraftMode) {
                speedDialItems.push({
                    label: t('layerControl.label_show_intersect'),
                    icon: 'pi pi-eye',
                    command: async (e) => {
                        e.originalEvent.preventDefault();
                        e.originalEvent.stopPropagation();
                        this.setState({ selectedIntersectLayers: [] });
                        var result = await TreeService.GetIntersectTableDataForLayerId(this.state.selectedDraftTable.id, node.id);
                        if (result.success) {
                            this.setState({ selectedIntersectLayers: result.data.map(x => x.id) });
                        }
                    }
                });
            }
            if (this.state.permissions.find(x => x.id === node.id && x.isWrite === true) != undefined) {

                speedDialItems = [
                    {
                        label: t('layerControl.label_delete_layer'),
                        icon: 'pi pi-ban',
                        command: (e) => {
                            e.originalEvent.preventDefault();
                            e.originalEvent.stopPropagation();
                            this.speddDialClick(node);
                            this.setState({ deletedNode: node });
                            this.confirm(e);
                        }
                    },
                    {
                        label: t('layerControl.label_add_sub_layer'),
                        icon: 'pi pi-plus',
                        command: (e) => {
                            e.originalEvent.preventDefault();
                            e.originalEvent.stopPropagation();
                            this.speddDialClick(node);
                            this.handleAddClick(node)
                        }
                    }

                ];

                speedDialItems.push({
                    label: t('layerControl.label_drawing_operations'),
                    icon: 'pi pi-pencil',
                    command: async (e) => {
                        e.originalEvent.preventDefault();
                        e.originalEvent.stopPropagation();
                        if (! await this.checkLockStatus(node)) {
                            return;
                        }

                        this.setState({ handleDrawAction: false });
                        await this.lockEntity(node.id);

                        this.mapTool.getMap().un('singleclick', window.mapSingleclick);

                        const geomType = await this.getLayerStructure(node);
                        if (geomType == 4) {
                            this.toast.current.show({
                                severity: 'warn',
                                summary: t('layerControl.toast_info'),
                                detail: t('layerControl.toast_draw_not_allowed_on_objectless_layer')
                            });
                            return;
                        }
                        this.speddDialClick(node);
                        this.props.setIsLoading(true);
                        this.setState({ handleDrawAction: true, selectedDrawLayer: node });
                        setTimeout(() => {
                            this.props.setIsLoading(false);
                        }, 100);


                    }
                });

                // Çocuklardan geometri oluştur (child varsa)
                if (node.children && node.children.length > 0) {
                    speedDialItems.push({
                        label: t('layerControl.create_geometry_from_children'),
                        icon: 'pi pi-expand',
                        command: async (e) => {
                            e.originalEvent.preventDefault();
                            e.originalEvent.stopPropagation();

                            this.speddDialClick(node);

                            this.setState({
                                selectedNodeCreateGeometryFromChildren: node
                            });
                            this.showConfirmCreateGeometryFromChildren(e);
                        }
                    });
                }


                speedDialItems.push({
                    label: t('layerControl.label_info'),
                    icon: 'pi pi-info',
                    command: (e) => {
                        e.originalEvent.preventDefault();
                        e.originalEvent.stopPropagation();
                        this.getLayerStructure(node);
                        this.speddDialClick(node);
                        this.setState({ handleInfoPageAction: !this.state.handleInfoPageAction, selectedDrawNode: node });
                    }
                });
               

                if (node.children && node.children.length > 0) {
                    speedDialItems.push({
                        label: t('layerControl.label_toggle_all_poi'),
                        icon: 'pi pi-map-marker',
                        command: (e) => {

                            e.originalEvent.preventDefault();
                            e.originalEvent.stopPropagation();
                            this.speddDialClick(node);
                            this.showPoi(node, true);

                        }
                    });
                }

                speedDialItems.push({
                    label: t('layerControl.label_toggle_geometry'),
                    icon: 'pi pi-eye',
                    command: (e) => {

                        e.originalEvent.preventDefault();
                        e.originalEvent.stopPropagation();
                        this.speddDialClick(node);
                        this.showGeometry(node);
                    }
                });
            }

            speedDialItems.push({
                label: t('layerControl.label_toggle_poi'),
                icon: 'pi pi-map-marker',
                command: (e) => {

                    e.originalEvent.preventDefault();
                    e.originalEvent.stopPropagation();
                    this.speddDialClick(node);
                    this.showPoi(node, false);

                }
            });
            return {
                ...node,
                label: (
                    <div style={{ display: 'flex', alignItems: 'center', position: 'relative', color: isNodeSelected ? 'orange' : (this.state.selectedIntersectLayers.includes(node.id) ? 'red' : 'black') }}>
                        <span style={{ marginTop: '5px', pointerEvents: 'all' }} title={nodeNameTooltip}>{nameShort}</span>
                        <div style={{ flex: '1', display: 'block', width: '50px' }}></div>
                        <div className="tree-operation-buttons">
                            <SplitButton tooltip={t('layerControl.label_operations')} text model={speedDialItems} size="small" dropdownIcon="pi pi-ellipsis-v" buttonClassName="bs-primary-color" onClick={this.speddDialClick} onShow={this.speddDialClick} onHide={this.speddDialClick} />
                        </div>
                    </div>
                ),
                key: node.id,
                children: node.children && this.createCustomTreeNodes(node.children),
            };
        });
    };

    showConfirmCreateGeometryFromChildren = (event) => {

        const { t } = this.props;

        confirmDialog({
            target: event.currentTarget,
            message: t('addGeometry.confirm_message'),
            header: t('addGeometry.confirm_title'),
            icon: 'pi pi-info-circle',
            defaultFocus: 'reject',
            acceptClassName: 'p-button-success',
            accept: this.acceptCreateGeoloc,
            reject: this.rejectCreateGeoloc,
            acceptLabel: t('addGeometry.confirm_yes'),
            rejectLabel: t('addGeometry.confirm_no'),
        });


    }

    acceptCreateGeoloc = async () => {

        const { t } = this.props;

        if (!this.state.selectedNodeCreateGeometryFromChildren) {
            this.toast.current.show({
                severity: 'info',
                summary: t('layerControl.toast_info'),
                detail: t('layerControl.toast_select_record')
            });
            return;
        }

        try {
            this.props.setIsLoading(true);
            await new Promise(r => setTimeout(r, 0)); // let the overlay render

            // 2) Basic validations
            if (this.state.isDraftMode && !this.state.selectedDraftTable) {
                this.toast.current.show({
                    severity: 'warn',
                    summary: t('layerControl.toast_info'),
                    detail: t('layerControl.toast_select_draft_table'),
                    life: 3000
                });
                return;
            }


            // 4) Call API and AWAIT it
            if (this.state.isDraftMode) {
                const tableId = this.state.selectedDraftTable.id;
                const nodeId = this.state.selectedNodeCreateGeometryFromChildren.id;
                const requestData = {
                    id: nodeId,
                    tableId
                };

                const res = await TreeService.createGeometryFromChildren(requestData);
                if (res?.success) {
                    this.toast.current.show({
                        severity: 'success',
                        summary: t('addGeometry.toast_info'),
                        detail: t('addGeometry.toast_geometry_added')
                    });
                } else {
                    throw new Error(res?.message || 'addGeometry failed');
                }
            } else {
                const nodeId = this.state.selectedNodeCreateGeometryFromChildren.id;
                const requestData = {
                    id: nodeId
                };
                const res = await TreeService.createGeometryFromChildren(requestData);
                if (res?.success) {
                    this.toast.current.show({
                        severity: 'success',
                        summary: t('addGeometry.toast_info'),
                        detail: t('addGeometry.toast_geometry_added')
                    });
                } else {
                    throw new Error(res?.message || 'addGeometry failed');
                }
            }
        } catch (error) {
            this.toast.current.show({
                severity: 'error',
                summary: t('addGeometry.toast_info'),
                detail: t('addGeometry.toast_geometry_not_updated')
            });
            console.error(error);
        } finally {
            // 5) Turn loader OFF after async work is actually done
            this.props.setIsLoading(false);
            this.setState({
                selectedNodeCreateGeometryFromChildren: null
            })
        }
    }

    rejectCreateGeoloc = () => {
        return;
    }

    deleteSelectedLayers = () => {
        const { t } = this.props;

        if (this.state.selectedDeleteLayers.length < 1) {
            this.toast.current.show({
                severity: 'warn',
                summary: t('layerControl.toast_info'),
                detail: t('layerControl.toast_no_selected_layers')
            });
            return;
        }

        const { treeData, selectedDeleteLayers } = this.state;
        const idList = selectedDeleteLayers.map(item => parseInt(item));
        const names = this.getFilteredNames(treeData, idList);

        this.setState({
            showDeleteLayersDialog: true,
            selecteDeleteNames: [...names]
        });
    };


    getFilteredNames = (dataList, idList) => {
        let names = [];

        dataList.forEach(item => {
            if (idList.includes(item.id)) {
                names.push(item.name);
            }
            if (item.children && item.children.length > 0) {
                names = names.concat(this.getFilteredNames(item.children, idList));
            }
        });

        return names;
    }

    createTreeNodes = (nodes) => {
        if (!nodes) {
            return;
        }

        return nodes.map((node) => {
            return {
                ...node,
                label: (
                    <div onClick={(e) => {

                        if (this.props.onSelectedNode) {
                            this.props.onSelectedNode(node);
                        }
                    }} >

                        <div onClick={(e) => {

                            if (this.props.onSelectedNode) {
                                this.props.onSelectedNode(node);
                            }
                        }} >
                            <span style={{ marginTop: '8px' }} onClick={(e) => {

                                if (this.props.onSelectedNode) {
                                    this.props.onSelectedNode(node);
                                }
                            }} >{node.name} <this.getReadEditTemplate node={node}></this.getReadEditTemplate>    </span>

                        </div>

                    </div>
                ),
                key: node.id,
                children: node.children && this.createTreeNodes(node.children),
            };
        });
    };
    getReadEditTemplate = (node) => {
        const { t } = this.props;

        let item = this.props.selectedNodes && this.props.selectedNodes.find(x => x.layerId === node.node.id);
        if (!item) return null;

        return (
            <>
                <Tag value={t('layerControl.tag_read')} severity={item.isShow ? "success" : "danger"}></Tag>
                <Tag style={{ marginLeft: "5px" }} value={t('layerControl.tag_edit')} severity={item.isEdit ? "success" : "danger"}></Tag>
            </>
        );
    };


    clearShowLayer = () => {
        this.mapTool.findLayer("workspace-layer").getSource().clear();
    }
    hexToRGBA = (hex, opacity) => {
        if (!hex)
            return null;

        // Remove the hash at the start if it's there
        hex = hex.replace(/^#/, '');

        // Parse the hex value
        let r = parseInt(hex.substring(0, 2), 16);
        let g = parseInt(hex.substring(2, 4), 16);
        let b = parseInt(hex.substring(4, 6), 16);

        // Ensure opacity is between 0 and 1
        opacity = Math.max(0, Math.min(opacity, 1));

        return `rgba(${r}, ${g}, ${b}, ${opacity})`;
    }
    showPoi = (node, isChildAll) => {
        const { t } = this.props;

        otherTool.addPopup(this.mapTool, "customer_info", "workspace-layer", "customer-popup");

        let _features = this.mapTool.findLayer("workspace-layer").getSource().getFeatures();

        let _id = node.id;
        let isShowPoi = false;
        let isShowGroupPoi = false;
        for (var i = 0; i < _features.length; i++) {
            let _findFeaturePoi = _features[i].get("layer_id_poi");
            let _findFeaturePoiGroup = _features[i].get("layer_id_poi_group");

            if (_findFeaturePoi) {
                isShowPoi = true;
                this.mapTool.findLayer("workspace-layer").getSource().removeFeature(_features[i]);
            }
            if (_findFeaturePoiGroup) {
                isShowGroupPoi = true;
                this.mapTool.findLayer("workspace-layer").getSource().removeFeature(_features[i]);
            }
        }

        if (isShowPoi && !isShowGroupPoi) {
            this.toast.current.show({ severity: 'info', summary: t('layerControl.toast_info'), detail: t('layerControl.toast_poi_removed') });
            return;
        }
        if (isShowGroupPoi && !isShowPoi) {
            return this.toast.current.show({ severity: 'info', summary: t('layerControl.toast_info'), detail: t('layerControl.toast_all_poi_removed') });
        }

        let data = {
            key: "id",
            value: _id.toString()
        };
        this.props.setIsLoading(true);

        if (this.state.isDraftMode) {
            const tableId = this.state.selectedDraftTable.id;

            TreeService.queryTableDraft(data, tableId).then(res => {
                if (!res.success) {
                    this.toast.current.show({ severity: 'warn', summary: t('layerControl.toast_info'), detail: t('layerControl.toast_layer_not_found') });
                    this.props.setIsLoading(false);
                    return;
                }
                if (!res.data[0].point_wkt) {
                    this.toast.current.show({ severity: 'warn', summary: t('layerControl.toast_info'), detail: t('layerControl.toast_poi_not_found') });
                    this.props.setIsLoading(false);
                    return;
                }

                let _wkt = res.data[0].point_wkt;
                let _feature = MapTool.convertToFeature(_wkt, "EPSG:4326", "EPSG:3857");

                _feature.set(isChildAll ? "layer_id_poi_group" : "layer_id_poi", res.data[0].id);

                this.props.setIsLoading(false);

                if (_feature.getGeometry().getType() === "Point") {
                    if (res.data[0].icon) {
                        _feature.setStyle(this.mapTool.setFeatureStyleIcon({ src: res.data[0].icon }));
                    } else if (res.data[0].icon === process.env.PUBLIC_URL + "/marker.png") {
                        _feature.setStyle(this.mapTool.setFeatureStyleIcon({ src: process.env.PUBLIC_URL + "/marker.png" }));
                    } else {
                        _feature.setStyle(this.mapTool.setFeatureStyleIcon({
                            isCircle: true,
                            strokeWidth: 1,
                            strokeColor: '#000',
                            fillColor: !res.data[0]["backgroundcolor"]
                                ? 'rgba(0, 0, 255, 0.1)'
                                : this.hexToRGBA(res.data[0]["backgroundcolor"], this.state.opacity)
                        }));
                    }

                    this.mapTool.addFeature("workspace-layer", _feature);
                    this.mapTool.viewLayerExtent("workspace-layer", _feature, 18);
                    return;
                }
            });

            return;
        }

        TreeService.queryTableIdFromChild(_id, isChildAll).then(res => {
            this.props.setIsLoading(false);

            if (!res.success) {
                this.toast.current.show({ severity: 'warn', summary: t('layerControl.toast_info'), detail: t('layerControl.toast_layer_not_found') });
                this.props.setIsLoading(false);
                return;
            }
            if (res.data.length < 1) {
                this.toast.current.show({ severity: 'warn', summary: t('layerControl.toast_info'), detail: t('layerControl.toast_poi_not_found') });
                this.props.setIsLoading(false);
                return;
            }

            for (const element of res.data) {
                let _wkt = element.point_wkt;
                if (!_wkt) continue;

                let _feature = MapTool.convertToFeature(_wkt, "EPSG:4326", "EPSG:3857");
                _feature.set("layer_id_poi", element.id);

                if (_feature.getGeometry().getType() === "Point") {
                    if (res.data[0].icon) {
                        _feature.setStyle(this.mapTool.setFeatureStyleIcon({ src: element.icon }));
                    } else if (res.data[0].icon === process.env.PUBLIC_URL + "/marker.png") {
                        _feature.setStyle(this.mapTool.setFeatureStyleIcon({ src: process.env.PUBLIC_URL + "/marker.png" }));
                    } else {
                        _feature.setStyle(this.mapTool.setFeatureStyleIcon({
                            isCircle: true,
                            strokeWidth: 1,
                            strokeColor: '#000',
                            fillColor: !res.data[0]["backgroundcolor"]
                                ? 'rgba(0, 0, 255, 0.1)'
                                : this.hexToRGBA(element["backgroundcolor"], this.state.opacity)
                        }));
                    }
                    _feature.set("layerName", "workspace-layer");
                    _feature.set("customer_info", { name: element.name });

                    this.mapTool.addFeature("workspace-layer", _feature);
                }

                if (isChildAll) {
                    this.mapTool.viewLayerExtent("workspace-layer");
                } else {
                    this.mapTool.viewLayerExtent("workspace-layer", _feature, 18);
                }
            }
        });
    };




    showGeometry = (node) => {
        const { t } = this.props;

        let _features = this.mapTool.findLayer("workspace-layer").getSource().getFeatures();
        let _id = node.id;
        let _findFeature = _features.find(i => i.get("layer_id") == _id);

        if (_findFeature) {
            this.mapTool.findLayer("workspace-layer").getSource().removeFeature(_findFeature);
            return;
        }

        let data = { key: "id", value: _id.toString() };
        this.props.setIsLoading(true);

        if (this.state.isDraftMode) {
            const tableId = this.state.selectedDraftTable.id;

            TreeService.queryTableDraft(data, tableId).then(res => {
                if (!res.success) {
                    this.toast.current.show({ severity: 'warn', summary: t('layerControl.toast_info'), detail: t('layerControl.toast_layer_not_found') });
                    this.props.setIsLoading(false);
                    return;
                }
                if (!res.data[0].geoloc_wkt) {
                    this.toast.current.show({ severity: 'warn', summary: t('layerControl.toast_info'), detail: t('layerControl.toast_geometry_not_found') });
                    this.props.setIsLoading(false);
                    return;
                }

                let _wkt = res.data[0].geoloc_wkt;
                let _feature = MapTool.convertToFeature(_wkt, "EPSG:4326", "EPSG:3857");
                _feature.set("layer_id", res.data[0].id);

                let _text = new Text({
                    text: res.data[0].name,
                    font: '12px Arial',
                    fill: new Fill({ color: '#000' })
                });

                this.props.setIsLoading(false);

                let _style = null;

                if (_feature.getGeometry().getType() === "Point") {
                    if (res.data[0].icon) {
                        _feature.setStyle(this.mapTool.setFeatureStyleIcon({ src: res.data[0].icon }));
                    } else if (res.data[0].icon === process.env.PUBLIC_URL + "/marker.png") {
                        _feature.setStyle(this.mapTool.setFeatureStyleIcon({ src: process.env.PUBLIC_URL + "/marker.png" }));
                    } else {
                        _feature.setStyle(this.mapTool.setFeatureStyleIcon({
                            isCircle: true,
                            strokeWidth: 1,
                            strokeColor: '#000',
                            fillColor: !res.data[0]["backgroundcolor"] ? 'rgba(0, 0, 255, 0.1)' : this.hexToRGBA(res.data[0]["backgroundcolor"], this.state.opacity)
                        }));
                    }
                    this.mapTool.addFeature("workspace-layer", _feature);
                    this.mapTool.viewLayerExtent("workspace-layer", _feature, 18);
                    return;
                } else {
                    _style = new OLStyle({
                        text: _text,
                        fill: new Fill({
                            color: !res.data[0]["backgroundcolor"] ? 'rgba(0, 0, 255, 0.1)' : this.hexToRGBA(res.data[0]["backgroundcolor"], this.state.opacity)
                        }),
                        stroke: new Stroke({
                            color: 'blue',
                            width: 1
                        })
                    });
                    _feature.setStyle(_style);
                }

                this.mapTool.addFeature("workspace-layer", _feature);
                let extent = _feature.getGeometry().getExtent();
                this.mapTool.getMap().getView().fit(extent, this.mapTool.getMap().getSize());
            });
            return;
        }

        TreeService.queryTable(data).then(res => {
            if (!res.success) {
                this.toast.current.show({ severity: 'warn', summary: t('layerControl.toast_info'), detail: t('layerControl.toast_layer_not_found') });
                this.props.setIsLoading(false);
                return;
            }
            if (!res.data[0].geoloc_wkt) {
                this.toast.current.show({ severity: 'warn', summary: t('layerControl.toast_info'), detail: t('layerControl.toast_geometry_not_found') });
                this.props.setIsLoading(false);
                return;
            }

            let _wkt = res.data[0].geoloc_wkt;
            let _feature = MapTool.convertToFeature(_wkt, "EPSG:4326", "EPSG:3857");
            _feature.set("layer_id", res.data[0].id);

            let _text = new Text({
                text: res.data[0].name,
                font: '12px Arial',
                fill: new Fill({ color: '#000' })
            });

            this.props.setIsLoading(false);

            let _style = null;

            if (_feature.getGeometry().getType() === "Point") {
                if (res.data[0].icon) {
                    _feature.setStyle(this.mapTool.setFeatureStyleIcon({ src: res.data[0].icon }));
                } else if (res.data[0].icon === process.env.PUBLIC_URL + "/marker.png") {
                    _feature.setStyle(this.mapTool.setFeatureStyleIcon({ src: process.env.PUBLIC_URL + "/marker.png" }));
                } else {
                    _feature.setStyle(this.mapTool.setFeatureStyleIcon({
                        isCircle: true,
                        strokeWidth: 1,
                        strokeColor: '#000',
                        fillColor: !res.data[0]["backgroundcolor"] ? 'rgba(0, 0, 255, 0.1)' : this.hexToRGBA(res.data[0]["backgroundcolor"], this.state.opacity)
                    }));
                }
                this.mapTool.addFeature("workspace-layer", _feature);
                this.mapTool.viewLayerExtent("workspace-layer", _feature, 18);
                return;
            } else {
                _style = new OLStyle({
                    text: _text,
                    fill: new Fill({
                        color: !res.data[0]["backgroundcolor"] ? 'rgba(0, 0, 255, 0.1)' : this.hexToRGBA(res.data[0]["backgroundcolor"], this.state.opacity)
                    }),
                    stroke: new Stroke({
                        color: 'blue',
                        width: 1
                    })
                });
                _feature.setStyle(_style);
            }

            this.mapTool.addFeature("workspace-layer", _feature);
            let extent = _feature.getGeometry().getExtent();
            this.mapTool.getMap().getView().fit(extent, this.mapTool.getMap().getSize());
        });
    };



}
export default withTranslation()(LayerControl);